import { render, staticRenderFns } from "./stream3.vue?vue&type=template&id=33f57ee0&"
import script from "./stream3.vue?vue&type=script&lang=js&"
export * from "./stream3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports